import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AudienceSeatingLayoutEntry.html?raw';
import { AudienceSeatingLayoutsEditor } from '../../MainCatalogEditorTools';
import { MainCatalogTypes, MainCatalogs_Classes } from "../../../_loadingHelpers/MainCatalogTypes";

class AudienceSeatingLayoutEntry extends compose(_WidgetBaseSP) {
    templateString: any = template;

    editor: MdsLax<InstanceType<typeof AudienceSeatingLayoutsEditor>>;

    isToDelete: boolean = false;

    audienceSeatingHeader: HTMLElement;
    audienceSeatingButtonEdit: HTMLButtonElement;
    audienceSeatingButtonHide: HTMLButtonElement;
    audienceSeatingButtonDelete: HTMLButtonElement;

    audienceSeatingEditContainer: HTMLElement;

    setEntry(isNew: boolean, entry?: MainCatalogTypes.AudienceSeatingLayoutsEditor_LoadData): void {

        this.editor = new AudienceSeatingLayoutsEditor();

        this.editor.prepareFormData(entry);
        this.editor.placeAt(this.audienceSeatingEditContainer);
        this.editor.hideSaveButton(true);
        this.editor.on("SerializeData", lang.hitch(this, this._onEditor__SerializeData))

        if (isNew) {

            this.audienceSeatingHeader.innerHTML = this.translations["MainCatalogsEditor_AudienceSeatingLayoutEntry_NewEntryHeader"];
            this.UiModder.domClass.replace(this.domNode, "mds-bg-yellow", "mds-bg-green");
            this.UiModder.domClass.add(this.audienceSeatingButtonEdit, "w3-hide");
            this.UiModder.domClass.remove(this.audienceSeatingButtonHide, "w3-hide");
            this.UiModder.domClass.remove(this.audienceSeatingEditContainer, "w3-hide");
        } else {

            this.audienceSeatingHeader.innerHTML = entry ? entry.code : "";
            this.UiModder.domClass.remove(this.audienceSeatingButtonEdit, "w3-hide");
        }
    }

    _onEditor__SerializeData() {
        this.emit("SerializeData");
    }

    _onClickButtonDelete(): void {
        this.isToDelete = !this.isToDelete;
        this.editor.formData.is_to_delete = this.isToDelete;

        if (this.isToDelete) {

            if (this.editor.formData.is_new_status === true) {

                this.emit("AudienceSeatingLayout_Destroy");
                this.destroy();
                return;
            }

            this.UiModder.domClass.replace(this.domNode, "w3-pale-red", "mds-bg-green");
            this.audienceSeatingButtonDelete.innerHTML = this.translations["GenericDialog__Btn_Cancel"];
        } else {

            this.UiModder.domClass.replace(this.domNode, "mds-bg-green", "w3-pale-red");
            this.audienceSeatingButtonDelete.innerHTML = this.translations["General_Delete"];
        }

        this.editor.serializeFormData();
    }

    _onClickButtonEdit(): void {

        this.UiModder.domClass.remove(this.audienceSeatingEditContainer, "w3-hide");
        this.UiModder.domClass.add(this.audienceSeatingButtonEdit, "w3-hide");
        this.UiModder.domClass.remove(this.audienceSeatingButtonHide, "w3-hide");
    }

    _onClickButtonHide(): void {

        this.UiModder.domClass.add(this.audienceSeatingEditContainer, "w3-hide");
        this.UiModder.domClass.remove(this.audienceSeatingButtonEdit, "w3-hide");
        this.UiModder.domClass.add(this.audienceSeatingButtonHide, "w3-hide");
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AudienceSeatingLayoutEntry);